import { Vector3 as BABYLON_Vector3 } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.vector.js';
import { PostProcess as BABYLON_PostProcess } from '@inter-ikea-betrakta-babylonjs/core/PostProcesses/postProcess.js';
import { Camera as BABYLON_Camera } from '@inter-ikea-betrakta-babylonjs/core/Cameras/camera.js';
// Side effect
import '../shaders/edge_sketch.fragment.js';
import { matrix_pool } from '../../Math.js';
const SAMPLER_DEPTH = 'depthSampler';
const INVERSE_DEPTH_DIMENSIONS = 'inverseDepthDimensions';
const INVERSE_PROJECTION_MATRIX = 'inverseProjectionMatrix';
/**
 * This class is an experimental feature for space, where they wanted to render a "printout" of the scene.
 * It's just black and white image, with blacks on edges
 */
export class EdgeSketchEffect {
    constructor(scene) {
        this._postprocess_camera = new BABYLON_Camera('', BABYLON_Vector3.Zero(), scene, false);
        this._effect = new BABYLON_PostProcess('edge_sketch', 'edge_sketch', [INVERSE_DEPTH_DIMENSIONS, INVERSE_PROJECTION_MATRIX], [SAMPLER_DEPTH], 1, this._postprocess_camera);
    }
    render(projection_matrix, depth_texture, render_target) {
        this._effect.onApply = (effect) => {
            effect.setTexture(SAMPLER_DEPTH, depth_texture);
            effect.setFloat2(INVERSE_DEPTH_DIMENSIONS, 1.0 / depth_texture.getSize().width, 1.0 / depth_texture.getSize().height);
            const inverse_projection_matrix = projection_matrix.invertToRef(matrix_pool.fetch());
            effect.setMatrix(INVERSE_PROJECTION_MATRIX, inverse_projection_matrix);
            matrix_pool.return(inverse_projection_matrix);
        };
        this._postprocess_camera._scene.postProcessManager.directRender([this._effect], render_target, true, undefined, undefined, render_target === undefined);
    }
    dispose() {
        this._effect.dispose();
        this._postprocess_camera.dispose();
    }
    effects_compiled() {
        return new Promise((resolve) => {
            if (this._effect.isReady()) {
                resolve();
            }
            else {
                this._effect.getEffect().onCompileObservable.add(() => { resolve(); });
            }
        });
    }
}
//# sourceMappingURL=EdgeSketchEffect.js.map